module.exports = __webpack_public_path__ + "img/Grupo 1332@2x.0f8fec54.png";